export type DraftDocumentBufferSourceKind = 'version' | 'checkpoint';

export interface DraftDocumentBufferCandidate {
  buffer: ArrayBuffer | null;
  error: unknown;
  isLoading: boolean;
  isValidating: boolean;
}

export interface DraftDocumentBufferSource extends DraftDocumentBufferCandidate {
  kind: DraftDocumentBufferSourceKind;
  sourceKey: string;
}

export interface ResolveDraftDocumentBufferSourceOptions {
  checkpoint: DraftDocumentBufferCandidate;
  checkpointGuid: string | null | undefined;
  preferCheckpoint: boolean;
  version: DraftDocumentBufferCandidate;
  versionNumber: number | null | undefined;
}

export function resolveDraftDocumentBufferSource({
  checkpoint,
  checkpointGuid,
  preferCheckpoint,
  version,
  versionNumber,
}: ResolveDraftDocumentBufferSourceOptions): DraftDocumentBufferSource {
  if (preferCheckpoint && checkpointGuid) {
    return {
      ...checkpoint,
      kind: 'checkpoint',
      sourceKey: `checkpoint:${checkpointGuid}`,
    };
  }

  return {
    ...version,
    kind: 'version',
    sourceKey: `version:${versionNumber ?? 'pending'}`,
  };
}
